import { gradientHorizontal } from '../../colors';

export const classes = {
  colorPrimary: {
    background: gradientHorizontal,
  },
  root: {
    boxShadow: 'none',
    justifyContent: 'center',
    flexDirection: 'row',
    zIndex: 3000,
  },
};
